import { render, staticRenderFns } from "./PaperPoster.vue?vue&type=template&id=4a545e99&scoped=true&"
import script from "./PaperPoster.vue?vue&type=script&lang=js&"
export * from "./PaperPoster.vue?vue&type=script&lang=js&"
import style0 from "./PaperPoster.vue?vue&type=style&index=0&id=4a545e99&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a545e99",
  null
  
)

component.options.__file = "PaperPoster.vue"
export default component.exports